import { DocumentsPage } from "./DocumentsPage";
import { DocumentsPageApiProvider } from "./useApiProvider";
import { DocumentsPageNavigationProvider } from "./useNavigation";

export function DocumentsPageContainer() {
  return (
    <DocumentsPageNavigationProvider>
      <DocumentsPageApiProvider>
        <DocumentsPage />
      </DocumentsPageApiProvider>
    </DocumentsPageNavigationProvider>
  );
}
